function miniCartHasMonkCvbWidget(miniCartEl) {
  if (!miniCartEl) return false;
  const monkRoot = miniCartEl.querySelector("#mr-div-embedded-cp-cvb-drawer");
  if (!monkRoot) return false;
  return !!monkRoot.querySelector(
    ".mr-embedded-widget--cvb, .mr-embedded-widget",
  );
}

function syncMiniCartFreeShippingWithMonk() {
  const inner = document.querySelector("#mini-cart .mini-cart__inner");
  if (!inner) return;
  inner.classList.toggle(
    "mini-cart--has-monk-cvb",
    miniCartHasMonkCvbWidget(document.getElementById("mini-cart")),
  );
}

let miniCartMonkObserver;

function observeMiniCartMonkCvb() {
  const miniCart = document.getElementById("mini-cart");
  if (!miniCart || miniCartMonkObserver) return;

  miniCartMonkObserver = new MutationObserver(() => {
    syncMiniCartFreeShippingWithMonk();
  });
  miniCartMonkObserver.observe(miniCart, { childList: true, subtree: true });
}

function afterMiniCartContentsUpdated() {
  syncMiniCartFreeShippingWithMonk();
  observeMiniCartMonkCvb();
}

window.afterMiniCartContentsUpdated = afterMiniCartContentsUpdated;

class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector("cart-drawer");
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    observeMiniCartMonkCvb();
    document.addEventListener("cart:updated", afterMiniCartContentsUpdated);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("mini-cart").innerHTML =
          this.getSectionInnerHTML(html, ".shopify-section");
        afterMiniCartContentsUpdated();
        if (
          typeof roarJs != "undefined" &&
          typeof roarJs.Legal != "undefined"
        ) {
          roarJs.Legal.refresh();
          roarJs.Legal.bindCheckoutEvents();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector("details");
    const wasOpen = detailsElement.hasAttribute("open");

    if (!wasOpen) {
      const summaryElement = this.drawer.querySelector("summary");
      summaryElement.click();
    }

    setTimeout(
      () => {
        setHeaderHeight();
        if (typeof this.drawer.moveFocusToDrawerContent === "function") {
          this.drawer.moveFocusToDrawerContent();
        }
      },
      wasOpen ? 0 : 450,
    );
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHtml = parsedState.sections?.[section.id];
      if (!target || !sectionHtml) return;

      const innerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (innerHtml != null) target.innerHTML = innerHtml;
    });
    afterMiniCartContentsUpdated();
    if (typeof roarJs != "undefined" && typeof roarJs.Legal != "undefined") {
      roarJs.Legal.refresh();
      roarJs.Legal.bindCheckoutEvents();
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const node = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return node ? node.innerHTML : null;
  }
}

customElements.define("mini-cart", MiniCart);
